"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _depositOrder = require("@/api/depositOrder.api");
var _product = require("@/api/product");
var _depositOrder2 = require("@/types/depositOrder");
var _lodash = require("lodash");
var _vuePropertyDecorator = require("vue-property-decorator");
var _AddProductOrderModal = _interopRequireDefault(require("./AddProductOrderModal.vue"));
var ProductOrderForm = /*#__PURE__*/function (_Vue) {
  function ProductOrderForm() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductOrderForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductOrderForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "statusForm", void 0);
    (0, _defineProperty2.default)(_this, "orderStatus", void 0);
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "compare", void 0);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "productId", null);
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "details", []);
    (0, _defineProperty2.default)(_this, "rules", {});
    (0, _defineProperty2.default)(_this, "summary", {
      totalPrice: 0,
      profit: 0
    });
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "DepositOrderStatus", _depositOrder2.DepositOrderStatus);
    (0, _defineProperty2.default)(_this, "debounceEstimate", (0, _lodash.debounce)(_this.handleEstimate, 500));
    return _this;
  }
  (0, _inherits2.default)(ProductOrderForm, _Vue);
  return (0, _createClass2.default)(ProductOrderForm, [{
    key: "dataTable",
    get: function get() {
      var summary = {
        totalPrice: 0,
        profit: 0
      };
      if (!this.form.details) {
        return [];
      }
      this.form.details.forEach(function (element, index) {
        element.totalPrice = element.quantity * element.retailPrice;
        // summary
        summary.totalPrice += element.totalPrice;
      });
      this.form.totalPrice = summary.totalPrice;
      return this.form.details;
    }
  }, {
    key: "watchDetails",
    value: function watchDetails() {
      this.debounceEstimate();
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "checkIsSoldProduct",
    value: function checkIsSoldProduct(item) {
      return !!item.sold;
    }
  }, {
    key: "handleAddProduct",
    value: function handleAddProduct() {
      this.$refs.productModal.handleCreate();
    }
  }, {
    key: "handleEstimate",
    value: function () {
      var _handleEstimate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this$form$details;
        var data, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if ((_this$form$details = this.form.details) !== null && _this$form$details !== void 0 && _this$form$details.length) {
                _context.next = 4;
                break;
              }
              this.$set(this.form, "moneyTax", null);
              this.$set(this.form, "moneyFinal", null);
              return _context.abrupt("return");
            case 4:
              data = {
                depositOrder: {
                  receiverName: this.form.receiverName,
                  receiverPhone: this.form.receiverPhone,
                  receiverAddress: this.form.receiverAddress
                },
                details: this.form.details.map(function (e) {
                  return {
                    price: e.retailPrice,
                    quantity: e.quantity,
                    productId: e.id,
                    lotNumber: e.lotNumber,
                    dateOfManufacture: e.dateOfManufacture,
                    expired: e.expired
                  };
                })
              };
              _context.next = 7;
              return _depositOrder.depositOrderApi.estimate(data);
            case 7:
              res = _context.sent;
              this.$set(this.form, "moneyTax", res.data.moneyTax);
              this.$set(this.form, "moneyFinal", res.data.moneyFinal);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleEstimate() {
        return _handleEstimate.apply(this, arguments);
      }
      return handleEstimate;
    }()
  }, {
    key: "handleChangeProduct",
    value: function handleChangeProduct(data) {
      // if (this.form.products.some((e) => e.id == product.id)) {
      //   return this.$message.error("This product is exist!");
      // }
      var productData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data.product), {}, {
        lotNumber: data.lotNumber,
        expired: data.expired,
        dateOfManufacture: data.dateOfManufacture,
        productQuantity: data.quantity,
        quantity: 1,
        totalPrice: 0,
        product: data.product
      });
      if (data.indexProduct != undefined) {
        var product = this.form.details[data.indexProduct];
        product = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, product), productData);
        this.form.details.splice(data.indexProduct, 1, product);
        return;
      }
      // check ton tai san pham và lotNumber giống lúc thêm thì tăng thêm số lượng
      var findIndex = this.form.details.findIndex(function (e) {
        return e.id == data.product.id && e.lotNumber == data.lotNumber;
      });
      if (findIndex > -1) {
        this.form.details[findIndex].quantity += 1;
        return;
      }
      if (data.product) {
        this.form.details.push((0, _objectSpread2.default)({}, productData));
      }
    }
  }, {
    key: "handleRemoveProd",
    value: function () {
      var _handleRemoveProd = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(index, item) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.statusForm == "update" && item.detailId)) {
                _context2.next = 7;
                break;
              }
              _context2.next = 3;
              return this.$confirm("Confirm delete product", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.form.details.splice(index, 1);
              this.$notify({
                title: "Delete product",
                message: "Successfully",
                type: "success"
              });
              _context2.next = 8;
              break;
            case 7:
              this.form.details.splice(index, 1);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleRemoveProd(_x, _x2) {
        return _handleRemoveProd.apply(this, arguments);
      }
      return handleRemoveProd;
    }()
  }, {
    key: "handleEditProd",
    value: function () {
      var _handleEditProd = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(index, item) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs.productModal.handleUpdate(index, item);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleEditProd(_x3, _x4) {
        return _handleEditProd.apply(this, arguments);
      }
      return handleEditProd;
    }()
  }, {
    key: "fetchProduct",
    value: function fetchProduct(search) {
      var _this2 = this;
      this.loading = true;
      _product.productApi.findAll({
        limit: 50,
        page: 1,
        search: search
      }).then(function (res) {
        return _this2.details = res.data.products;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], ProductOrderForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "statusForm", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "orderStatus", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "disabled", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "compare", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("dataTable", {
  deep: true
})], ProductOrderForm.prototype, "watchDetails", null);
ProductOrderForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    AddProductOrderModal: _AddProductOrderModal.default
  }
})], ProductOrderForm);
var _default = exports.default = ProductOrderForm;